<!-- Botão flutuante (só quando não está em chamada) -->
<button
    *ngIf="!activeRoom"
    type="button"
    class="calls-fab"
    mat-fab
    (click)="openSidebar()"
    [matTooltip]="'Chat' | autoTranslate"
    matTooltipPosition="left"
>
    <mat-icon
        svgIcon="heroicons_outline:chat-bubble-left-right"
        [matBadge]="totalUnread"
        [matBadgeHidden]="!totalUnread"
        matBadgePosition="above before"
        matBadgeColor="warn"
        matBadgeSize="small"
    ></mat-icon>
</button>

<!-- Sidebar fora de chamada -->
<app-calls-sidebar
    *ngIf="sidebarOpen && !activeRoom"
    [rooms]="roomsForSidebar"
    [conversations]="conversations"
    [contacts]="contacts"
    [activeConversation]="activeConversation"
    [currentUserId]="currentUserId"
    [currentUserName]="currentUserName"
    [companyId]="companyId"
    (close)="closeSidebar()"
    (enterRoom)="onEnterRoom($event)"
    (openConversation)="onOpenConversation($event)"
    (startDirectChat)="onStartDirectChat($event)"
    (enterVideoFromConversation)="onEnterVideoFromConversation($event)"
    (backToList)="onBackToList()"
    (groupCreated)="onGroupCreated($event)"
    (groupUpdated)="onGroupUpdated($event)"
    (groupDeleted)="onGroupDeleted($event)"
></app-calls-sidebar>

<!-- Chamada ativa -->
<ng-container *ngIf="activeRoom">
    <div
        class="calls-in-call-shell"
        [class.calls-in-call-shell--fullscreen]="callFullscreen"
        [class.calls-in-call-shell--with-chat]="callFullscreen && sidebarOpen"
    >
        <app-calls-in-call
            [room]="activeRoom"
            [participants]="inCallParticipants"
            [chatOpen]="sidebarOpen"
            (leave)="onLeaveCall()"
            (openChat)="openInCallSidebar()"
            (fullscreenChange)="onCallFullscreenChange($event)"
        ></app-calls-in-call>

        <app-calls-sidebar
            *ngIf="sidebarOpen && callFullscreen"
            [docked]="true"
            [rooms]="roomsForSidebar"
            [conversations]="conversations"
            [contacts]="contacts"
            [activeConversation]="activeConversation"
            [currentUserId]="currentUserId"
            [currentUserName]="currentUserName"
            [companyId]="companyId"
            (close)="closeSidebar()"
            (enterRoom)="onEnterRoom($event)"
            (openConversation)="onOpenConversation($event)"
            (startDirectChat)="onStartDirectChat($event)"
            (enterVideoFromConversation)="onEnterVideoFromConversation($event)"
            (backToList)="onBackToList()"
            (groupCreated)="onGroupCreated($event)"
            (groupUpdated)="onGroupUpdated($event)"
            (groupDeleted)="onGroupDeleted($event)"
        ></app-calls-sidebar>
    </div>
</ng-container>
